module.exports = __webpack_public_path__ + "static/img/img_cabinet.b4d36a94.png";